import { useEffect, useState } from 'react';
import { config } from '@/config';
import snapshot from '@/data/stations-snapshot.json';
import type { Station } from '@/domain/geo';
import { fetchStations, parseStations } from '@/services/stations';

type StationsState = { stations: Station[] };

/* The bundled snapshot renders first so the map has pins immediately: the live endpoint
   takes about 1.2 s to answer, and waiting on it left the page looking like it had no map
   at all. Live data replaces it on arrival. */
const SNAPSHOT_STATIONS = parseStations(snapshot);

export const useStations = (): StationsState => {
  const [state, setState] = useState<StationsState>({ stations: SNAPSHOT_STATIONS });

  useEffect(() => {
    let active = true;
    void fetchStations(config.stationsUrl).then((result) => {
      if (!active) {
        return;
      }
      setState({ stations: result.stations });
    });
    return () => {
      active = false;
    };
  }, []);

  return state;
};
